import React from 'react'

interface Props {
  active?: boolean
  onClick?: () => void
  icon: JSX.Element
}

const LessonIcon = ({ active = false, onClick, icon }: Props) => {
  return (
    <div
      className="w-[3rem] h-[3rem] border rounded-full border-white text-white p-2 relative overflow-hidden cursor-pointer"
      onClick={onClick}>
      {icon}
      {active && <div className="w-[160px] h-[2px] bg-white absolute rotate-45 left-[-40px] cursor-pointer" />}
    </div>
  )
}

export default LessonIcon
